import {VStack} from '@components/Stack'
import styles from '@components/Testimonial.module.css'
import {Text} from '@components/Text'
import {Icon} from 'src/Icon'

export function Testimonial({
  image,
  name,
  role,
  link,
  showQuoteIcon,
  children,
}) {
  return (
    <div
      className={styles.testimonial}
      data-person={name.toLowerCase().replace(/\s+/g, '-')}
    >
      {showQuoteIcon && (
        <div className={styles.testimonialQuoteIcon}>
          <Icon name="quote" marginRight="0" size="32" />
        </div>
      )}

      {image ? (
        <div>
          <picture>
            {typeof image === 'object' ? (
              <source
                srcSet={`/images/people/${image[0]}`}
                media="(min-width: 769px)"
              />
            ) : (
              <source srcSet={`/images/people/${image}`} />
            )}
            {typeof image === 'object' ? (
              <source
                srcSet={`/images/people/${image[1]}`}
                media="(max-width: 768px)"
              />
            ) : null}
            <img className={styles.testimonialImg} />
          </picture>
        </div>
      ) : null}
      <VStack gap="0.8rem" align="flex-start">
        <Text
          mono={false}
          size={2}
          weight={500}
          appearance="primary"
          letterSpacing="0.2px"
        >
          <VStack align="flex-start">
            {children}
            <div>
              {link ? (
                <a
                  href={link}
                  target="_blank"
                  className="link"
                  style={{color: 'var(--clr-brand)'}}
                >
                  {name}
                </a>
              ) : (
                <span style={{color: 'var(--clr-brand)'}}>{name}</span>
              )}
              <span style={{color: 'var(--clr-text-lightest-final)'}}>
                {' '}
                - {role}
              </span>
            </div>
          </VStack>
        </Text>
      </VStack>
    </div>
  )
}
